export function validateTagStructure(tag, tagSchema) {
    if (tag.type !== tagSchema.type) {
        return false;
    }
    if (!tagSchema.props) {
        return true;
    }
    if (!tag.props) {
        return false;
    }
    var requiredProps = Object.keys(tagSchema.props);
    return requiredProps.every(function (propName) {
        if (tagSchema.props[propName]) {
            return tag.props[propName] === tagSchema.props[propName];
        }
        return typeof tag.props[propName] === 'string';
    });
}
